import BulkManageMobileDrawer from "common/components/BulkManageMobileDrawer";
import type { Lead } from "common/types";

import { MANAGE_LEADS_ACTIONS } from "../../../constants";
import AddNotes from "../ManageLeads/AddNotes";
import FavoriteLeads from "../ManageLeads/FavoriteLeads";
import UpdateLabels from "../ManageLeads/UpdateLabels";

interface ManageLeadsProps {
  selectedLeads: Lead[];
}

export default function ManageLeads({ selectedLeads }: ManageLeadsProps) {
  return (
    <BulkManageMobileDrawer
      drawerLabel={"leads"}
      actions={MANAGE_LEADS_ACTIONS}
      selection={selectedLeads}
      renderActionComponent={({ action, onClose, onBack }) => {
        const commonProps = {
          selectedLeads,
          onBack,
          onClose,
        };
        if (action === "labels") {
          return <UpdateLabels {...commonProps} />;
        }
        if (action === "notes") {
          return <AddNotes {...commonProps} />;
        }
        return <FavoriteLeads action={action} {...commonProps} />;
      }}
    />
  );
}
